import { NavLink as RouterLink } from 'react-router-dom'
import LoginIcon from '@mui/icons-material/AccountCircleRounded'
import { useSelector } from 'react-redux'
import { Box, Typography, IconButton, Link } from '@mui/material'
import { PATH } from '../../../../routes/constant'
import { type IUserProfile } from '../../../../redux/api/types'
import PaymentPastDue from '../../../../components/PaymentPastDue'

const Login: React.FC = () => {
  const mode = useSelector((state: any) => state.modeState)
  const user: IUserProfile = useSelector((state: any) => state.userState.user)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mr: '16px'
      }}
    >
      { user?.isPaymentPastDue
        ? <PaymentPastDue color='error.main'/>
        : null
      }
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
      >
        <LoginIcon sx={{ color: 'rgba(195, 202, 217, 1)' }}/>
      </IconButton>
      <Typography
        component="div"
        sx= {{
          flexGrow: 1,
          color: '#6B7A99',
          fontSize: '14px',
          fontWeight: 700,
          letterSpacing: 0.01
        }}
      >
        <Link component={RouterLink}
          to={
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${mode.isWp === true ? `${process.env.REACT_APP_HOSTNAME}${PATH.ACCOUNT}` : PATH.ACCOUNT}`
          }
          sx = {{
            height: { xs: '40px', sm: '49px' },
            width: { xs: '40px', sm: '49px' }
          }}
        >
          {user?.firstName} {user?.secondName}
        </Link>
      </Typography>
    </Box>
  )
}

export default Login
